import React, { useEffect, useState } from "react";
import axiosInstance from "../axios/axios";
import editIcon from "../assets/editIcon.svg";
import Loader from "./Loader";
import SuccessMessage from "./SuccessMessage";

const StudentProfile = () => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [updatedUser, setUpdatedUser] = useState({});
  const [validationErrors, setValidationErrors] = useState({});

  const studentId = localStorage.getItem("role_specific_id");
  const userId = localStorage.getItem("user_id");

  const fetchUserById = async () => {
    if (!userId) {
      setError("User ID not found. Please log in again.");
      setLoading(false);
      return;
    }

    try {
      const response = await axiosInstance.get("all_users");
      const foundUser = response.data.users.find(
        (u) => u.user_id === parseInt(userId)
      );
      if (foundUser) {
        setUser(foundUser);
        setUpdatedUser(foundUser.student || {});
        setError(null);
      } else {
        setError("User not found");
      }
    } catch (error) {
      setError("Failed to fetch user data");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserById();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdatedUser((prev) => ({
      ...prev,
      [name]: value,
    }));
    setValidationErrors((prev) => ({
      ...prev,
      [name]: null, // Clear validation error for this field
    }));
  };

  const validateForm = () => {
    const errors = {};
    const requiredFields = [
      "full_name",
      "sex",
      "course_of_study",
      "degree",
      "status",
      "university",
    ];
    requiredFields.forEach((field) => {
      if (!updatedUser[field]) {
        errors[field] = `${field.replace("_", " ")} is required.`;
      }
    });
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const res = await axiosInstance.put(
        `student/${studentId}/update`,
        updatedUser
      );
      setUser((prev) => ({
        ...prev,
        student: updatedUser,
      }));
      console.log(res);
      setIsEditing(false);
      setSuccess(true);
      setError(null);
    } catch (error) {
      setError("Failed to update profile");
      console.error(error);
    }
  };

  if (loading) return <Loader />;
  if (error) return <p>{error}</p>;

  return (
    <div>
      <div className="flex flex-col justify-between items-center w-full top-bar "></div>
      <section className="md:mt-[20px] flex px-6 py-3 flex-col gap-6 max-w-[592px]">
        {!isEditing ? (
          <>
            <div className="flex w-full justify-between custom-section flex-col">
              <div className="flex flex-col gap-4">
                <span className="label-name w-full">Name</span>
                <span className="content-container">
                  {user?.student.full_name || "Not provided"}
                </span>
              </div>
              <div className="flex flex-col gap-4">
                <span className="label-name">Email</span>
                <span className="content-container">
                  {user?.email || "Not provided"}
                </span>
              </div>
            </div>
            <div className="flex flex-col gap-4">
              <span className="label-name">Sex</span>
              <span className="content-container">
                {user?.student.sex || "Not provided"}
              </span>
            </div>
            <div className="flex flex-col gap-4">
              <span className="label-name">Course Of Study</span>
              <span className="content-container">
                {user?.student.course_of_study || "Not provided"}
              </span>
            </div>
            <button
              className="flex gap-2 btn-success btn items-center justify-center my-3"
              onClick={() => setIsEditing(true)}
            >
              <img src={editIcon} alt="Edit" />
              <span>Edit</span>
            </button>
          </>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col gap-4">
              <label className="label-name w-full">Name</label>
              <input
                type="text"
                name="full_name"
                value={updatedUser.full_name || ""}
                onChange={handleInputChange}
                className="custom-form"
              />
              {validationErrors.full_name && (
                <span className="error">{validationErrors.full_name}</span>
              )}
            </div>
            <div className="flex flex-col gap-4">
              <label className="label-name">Gender</label>
              <select
                value={updatedUser.sex || ""}
                onChange={handleInputChange}
                name="sex"
                className="custom-form"
                id="sex"
              >
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
              {/* <input
                type="text"
                name="sex"
                value={updatedUser.sex || ""}
                onChange={handleInputChange}
                className="custom-form" 
              />
                */}
              {validationErrors.sex && (
                <span className="error">{validationErrors.sex}</span>
              )}
            </div>
            <div className="flex flex-col gap-4">
              <label className="label-name">Course of Study</label>
              <input
                type="text"
                name="course_of_study"
                value={updatedUser.course_of_study || ""}
                onChange={handleInputChange}
                className="custom-form"
              />
              {validationErrors.course_of_study && (
                <span className="error">
                  {validationErrors.course_of_study}
                </span>
              )}
            </div>
            <div className="flex flex-col gap-4">
              <label className="label-name">Degree</label>
              {/* <input type="text" name="degree" className="custom-form" />{" "} */}
              <select
                id="degree"
                name="degree"
                className="custom-form"
                value={updatedUser.degree || ""}
                onChange={handleInputChange}
              >
                <option value="" disabled>
                  Select your Degree
                </option>
                <option value="BSc">BSc</option>
                <option value="MSc">MSc</option>
                <option value="HND">HND</option>
                <option value="OND">OND</option>
                <option value="PhD">PhD</option>
              </select>
              {validationErrors.degree && (
                <span className="error">{validationErrors.degree}</span>
              )}
            </div>
            <div className="flex flex-col gap-4">
              <label className="label-name">University</label>
              <input
                type="text"
                name="university"
                value={updatedUser.university || ""}
                onChange={handleInputChange}
                className="custom-form"
              />
              {validationErrors.university && (
                <span className="error">{validationErrors.university}</span>
              )}
            </div>
            <button type="submit" className="btn-success btn">
              Save Changes
            </button>
            <button
              type="button"
              className="btn-danger btn mt-2"
              onClick={() => setIsEditing(false)}
            >
              Cancel
            </button>
          </form>
        )}
        {success && (
          <SuccessMessage
            message="Your action was successful!"
            onClose={() => setSuccess(false)}
            duration={3000} // Optional, defaults to 3000ms
          />
        )}
      </section>
    </div>
  );
};

export default StudentProfile;
